<template>
  <div>
    <div class="footer">
      <div class="content">
        <div class="left">
          <!-- <img class="logo" src="https://www.xaryxx.com/images/home/12.png" alt=""> -->
          <div class="detail">
            <div class="names">
              <img class="logo" src="../../../static/banner/2.png" alt="" />
              <div>荣业信息</div>
            </div>
            <!-- <img src="../../assets/2.png" alt="" srcset="">
            <img src="https://www.xaryxx.com/images/home/13.png" alt=""> -->
            <div class="desc">{{ info.companySlogan }}</div>
            <div class="link">网站导航</div>
            <ul>
              <li
                :class="current == index ? 'active' : ''"
                v-for="(item, index) in navList"
                :key="index"
                @click="opens(item, index)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="right">
          <div class="companyInfo">
            <div class="title">联系我们</div>
            <ul>
              <li>技术支持： {{ info.mobile }}</li>
              <li>公司地址： {{ info.companyAddress }}</li>
              <li>服务热线：{{ info.phone }}</li>
            </ul>
          </div>
          <div class="images-content">
            <div class="image-item" style="margin-right: 16px">
              <img
                src="https://mk001.oss-cn-hangzhou.aliyuncs.com/app/qq.png"
                alt=""
              />
            </div>
            <div class="image-item">
              <img
                src="https://mk001.oss-cn-hangzhou.aliyuncs.com/app/wx.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="CopyRight">
      CopyRight © 2023 西安荣业信息科技有限公司
      <div style="color: #fff; margin-top: 5px">
        <a
          style="color: #fff; font-size: 14px"
          href="https://beian.miit.gov.cn/"
          target="_black"
          >陕ICP备2023010036号</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { companyInfo } from "@/api/api";
export default {
  name: "footerContent",
  data() {
    return {
      navList: [
        { name: "首页", path: "/" },
        { name: "案例", path: "/pages/case/index" },
        { name: "服务", path: "/pages/service/index" },
        { name: "新闻中心", path: "/pages/news/index" },
        { name: "关于我们", path: "/pages/contact/index" },
        // { name: "联系我们", path: "/pages/service/sub" },
       
      ],
      current: 0,
      info: {},
    };
  },
  mounted() {
    this.getcompanyInfo();
  },
  methods: {
    getcompanyInfo() {
      companyInfo().then((response) => {
        this.info = response.data;
      });
    },
    opens: function (params, index) {
      this.current = index;
      // localStorage.setItem('current', index)
      this.$router.push({ path: params.path });
    },
  },
};
</script>

<style lang="less" scoped>
.CopyRight {
  padding: 0 0 19px 0;
  // background: #e76824;
  background: #5B5B5B;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 27px;
  text-align: center;
}

.footer {
  padding: 58px 0 68px 0;
  display: flex;

  justify-content: space-around;
  // background: #e76824;
  background: #5B5B5B;
  // background: #323232 !important;
  .content {
    width: 75%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .right {
      // padding-top: 42px;
      display: flex;
      align-items: center;
      .companyInfo {
        max-width: 300px;
        margin-right: 40px;
      }
      .images-content {
        display: flex;
        align-items: center;
        img {
          width: 91px;
          height: 91px;
        }
      }

      .title {
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 19px;
        margin-bottom: 11px;
      }

      ul {
        cursor: pointer;
        margin: 0;
        padding: 0;
        li {
          cursor: pointer;
          list-style-type: none;

          margin-bottom: 12px;
          font-family: PingFang SC;
          // font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          line-height: 27px;
          &:last-child{
              margin-bottom: 0;
            }
        }
      }
    }

    .left {
      display: flex;

      .detail {
        .names {
          display: flex;
          align-content: center;
          .logo {
            width: 30px;
            height: 30px;
            margin-right: 14px;
          }
          margin-bottom: 23px;
          // margin: 7px 0 23px 3px;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 18px;
          color: #ffffff;
          > div {
            margin-top: 3px;
          }
        }
        // img {
        //   width: 96px;
        //   height: 34px;
        //   margin-bottom: 23px;
        //   margin: 7px 0 23px 0;
        // }

        .desc {
          // font-size: 20px;
          // font-family: PingFang SC-Light, PingFang SC;
          // font-weight: 300;
          // color: #ffffff;
          // line-height: 23px;

          font-family: PingFang SC;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
        }

        .link {
          margin: 38px 0 10px 0;
          font-size: 16px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 19px;
        }

        ul {
          display: flex;
          margin: 0;
          padding: 0;
          cursor: pointer;

          li {
            list-style-type: none;
            font-size: 16px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            line-height: 27px;
            margin-right: 30px;
           

            // &:hover {
            //   font-size: 16px;
            //   font-family: PingFang SC-Medium, PingFang SC;
            //   font-weight: 500;
            //   line-height: 19px;
            //   background: linear-gradient(360deg, #ff8400 0%, #e32200 100%);
            //   -webkit-background-clip: text;
            //   -webkit-text-fill-color: transparent;
            // }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footerContent.vue